import { render } from "./FixIcon.vue?vue&type=template&id=68b3050a"
import script from "./FixIcon.vue?vue&type=script&lang=js"
export * from "./FixIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__